/*
 * @Author: your name
 * @Date: 2020-11-30 14:43:17
 * @LastEditTime: 2021-01-14 09:28:38
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vr-fornt-end\src\components\modeldemo\Device\Info.js
 */

function getOS () {
  return window.navigator.userAgent.indexOf('Android') > -1 ||
  window.navigator.userAgent.indexOf('Linux') > -1 ? 'Android'
    : window.navigator.userAgent.indexOf('iPhone') > -1 ? 'iOS'
      : window.navigator.userAgent.indexOf('Windows Phone') > -1 ? 'WP' : 'Others'
}

function getOSVersion () {
  var a = '1.0'
  var b = window.navigator.userAgent
  var isLinuxCore = b.indexOf('Android') > -1 || b.indexOf('Linux') > -1
  var isMacOS = !!b.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)

  if (isLinuxCore) {
    var e = /android [\d._]+/gi
    var f = b.match(e)
    if (f) {
      a = (f + '').replace(/[^0-9|_.]/gi, '').replace(/_/gi, '.')
      a = parseInt(a.split('.')[0])
    }
  }
  if (isMacOS) {
    a = window.navigator.userAgent.split(';')[1].match(/(\d+)_(\d+)_?(\d+)?/)[0]
  }

  return a
}

function getOrientation () {
  let rls = 'unknow'
  if (window.screen && window.screen.orientation && window.screen.orientation.angle) {
    if (window.screen.orientation.angle !== 180 && window.screen.orientation.angle !== 0) {
      rls = 'landscape'
    }
    if (window.screen.orientation.angle !== 90 && window.screen.orientation.angle !== -90) {
      rls = 'portrait'
    }
  }
  return rls
}

function device () {
  var ua = window.navigator.userAgent.toLowerCase()
  var ipad = ua.match(/(ipad)/i) === 'ipad'
  var iphone = ua.match(/iphone os/i) === 'iphone os'
  var midp = ua.match(/midp/i) === 'midp'
  var rv = ua.match(/rv:1.2.3.4/i) === 'rv:1.2.3.4'
  var uc = ua.match(/ucweb/i) === 'ucweb'
  var android = ua.match(/android/i) === 'android'
  var win = ua.match(/windows ce/i) === 'windows ce'
  var wp = ua.match(/windows mobile/i) === 'windows mobile'
  return ipad || iphone || midp || rv || uc || android || win || wp
    ? iphone || midp || rv || uc || android || win || wp
      ? 'phone'
      : ipad
        ? 'ipad' : 'unknow'
    : 'pc'
}

function getNetWork () {
  if (!window.navigator.connection) return 'defult'
  return window.navigator.connection.effectiveType
}

export function deviceInfo () {
  return {
    deviceType: device(),
    OS: getOS(),
    OSVersion: getOSVersion(),
    userAgent: window.navigator.userAgent,
    appVersion: window.navigator.appVersion,
    screenHeight: window.screen.height,
    screenWidth: window.screen.width,
    language: window.navigator.language,
    netWork: getNetWork(),
    orientation: getOrientation()
  }
}
